var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _circle2, _circle3, _circle4, _circle5, _path9, _circle6, _path10, _circle7, _path11, _path12, _circle8, _path13, _path14, _path15, _path16, _path17, _path18, _circle9, _path19, _path20, _path21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 763.811,
    height: 555.5,
    viewBox: "0 0 763.811 555.5",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M980.9055,727.75h-381a1,1,0,1,1,0-2h381a1,1,0,0,1,0,2Z",
    transform: "translate(-218.0945 -172.25)",
    fill: "#ccc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M929.78783,309.55859h-.84449a4.00458,4.00458,0,0,1-4-4V273.79492a4.00459,4.00459,0,0,1,4-4h.84449a4.00459,4.00459,0,0,1,4,4v31.76367A4.00458,4.00458,0,0,1,929.78783,309.55859Z",
    transform: "translate(-218.0945 -172.25)",
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M651.8679,270.79492h-.84472a4.00458,4.00458,0,0,1-4-4V248.40869a4.00458,4.00458,0,0,1,4-4h.84472a4.00458,4.00458,0,0,1,4,4v18.38623A4.00458,4.00458,0,0,1,651.8679,270.79492Z",
    transform: "translate(-218.0945 -172.25)",
    fill: "#e6e6e6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M651.8679,315.56348h-.84472a4.00458,4.00458,0,0,1-4-4V293.17676a4.00458,4.00458,0,0,1,4-4h.84472a4.00458,4.00458,0,0,1,4,4v18.38672A4.00458,4.00458,0,0,1,651.8679,315.56348Z",
    transform: "translate(-218.0945 -172.25)",
    fill: "#e6e6e6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M891.19847,726.728H689.61253A34.784,34.784,0,0,1,654.8679,691.9834V207.99463A34.784,34.784,0,0,1,689.61253,173.25H891.19847a34.78409,34.78409,0,0,1,34.74487,34.74463V691.9834A34.78409,34.78409,0,0,1,891.19847,726.728Z",
    transform: "translate(-218.0945 -172.25)",
    fill: "#f2f2f2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M891.19847,727.728H689.61253A35.7852,35.7852,0,0,1,653.8679,691.9834V316.13623a4.91168,4.91168,0,0,1-2,.42725h-.84472a5.00573,5.00573,0,0,1-5-5V293.17676a5.00573,5.00573,0,0,1,5-5h.84472a4.91183,4.91183,0,0,1,2,.42724V271.36768a4.91183,4.91183,0,0,1-2,.42724h-.84472a5.00573,5.00573,0,0,1-5-5V248.40869a5.00573,5.00573,0,0,1,5-5h.84472a4.91168,4.91168,0,0,1,2,.42725V207.99463A35.7852,35.7852,0,0,1,689.61253,172.25H891.19847a35.78546,35.78546,0,0,1,35.74512,35.74463v61.22754a4.91084,4.91084,0,0,1,2-.42725h.84424a5.00573,5.00573,0,0,1,5,5v31.76367a5.00573,5.00573,0,0,1-5,5h-.84424a4.91083,4.91083,0,0,1-2-.42724v381.852A35.78546,35.78546,0,0,1,891.19847,727.728ZM655.8679,311.51709V691.9834A33.78275,33.78275,0,0,0,689.61253,725.728H891.19847a33.783,33.783,0,0,0,33.74512-33.74463V305.51074l1.75317,2.00781a2.99223,2.99223,0,0,0,2.24683,1.04h.84424a3.00328,3.00328,0,0,0,3-3V273.79492a3.00328,3.00328,0,0,0-3-3h-.84424a2.99226,2.99226,0,0,0-2.24683,1.04l-1.75317,2.00781V207.99463A33.783,33.783,0,0,0,891.19847,174.25H689.61253a33.78275,33.78275,0,0,0-33.74463,33.74463v40.46045l-1.75293-2.00586a2.9948,2.9948,0,0,0-2.24707-1.04053h-.84472a3.00328,3.00328,0,0,0-3,3v18.38623a3.00328,3.00328,0,0,0,3,3h.84472a2.99476,2.99476,0,0,0,2.24707-1.04053l1.75293-2.00585v26.4746l-1.75293-2.00585a2.99476,2.99476,0,0,0-2.24707-1.04053h-.84472a3.00328,3.00328,0,0,0-3,3v18.38672a3.00328,3.00328,0,0,0,3,3h.84472A2.9948,2.9948,0,0,0,654.115,313.523Z",
    transform: "translate(-218.0945 -172.25)",
    fill: "#ccc"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M759.03905,309.55859h-55.125a31.90267,31.90267,0,0,1-31.86646-31.8667V213.792a31.90225,31.90225,0,0,1,31.86646-31.86621h55.125A31.90225,31.90225,0,0,1,790.9055,213.792v63.8999A31.90266,31.90266,0,0,1,759.03905,309.55859Z",
    transform: "translate(-218.0945 -172.25)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M759.03905,310.55859h-55.125a32.904,32.904,0,0,1-32.86646-32.8667V213.792a32.90356,32.90356,0,0,1,32.86646-32.86621h55.125A32.90355,32.90355,0,0,1,791.9055,213.792v63.8999A32.904,32.904,0,0,1,759.03905,310.55859Zm-55.125-127.63281A30.90142,30.90142,0,0,0,673.04759,213.792v63.8999a30.90153,30.90153,0,0,0,30.86646,30.8667h55.125a30.90152,30.90152,0,0,0,30.86645-30.8667V213.792a30.90142,30.90142,0,0,0-30.86645-30.86621Z",
    transform: "translate(-218.0945 -172.25)",
    fill: "#ccc"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 572.31102,
    cy: 273.22052,
    r: 26.94257,
    fill: "#00b0ff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 487.60721,
    cy: 43.23477,
    r: 16.80967,
    fill: "#2f2e41"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 487.60721,
    cy: 103.7496,
    r: 16.80967,
    fill: "#2f2e41"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 539.15688,
    cy: 73.19141,
    r: 16.80967,
    fill: "#2f2e41"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 487.60721,
    cy: 43.23477,
    r: 5.88339,
    fill: "#b3b3b3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M705.70164,222.36834a6.88355,6.88355,0,1,1,6.88354-6.88379A6.89127,6.89127,0,0,1,705.70164,222.36834Zm0-11.76709a4.88355,4.88355,0,1,0,4.88354,4.8833A4.88872,4.88872,0,0,0,705.70164,210.60125Z",
    transform: "translate(-218.0945 -172.25)",
    fill: "#e6e6e6"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 539.15683,
    cy: 73.19139,
    r: 5.88339,
    fill: "#b3b3b3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M757.25126,252.325a6.88355,6.88355,0,1,1,6.88354-6.88379A6.89128,6.89128,0,0,1,757.25126,252.325Zm0-11.76709a4.88355,4.88355,0,1,0,4.88354,4.8833A4.88871,4.88871,0,0,0,757.25126,240.55787Z",
    transform: "translate(-218.0945 -172.25)",
    fill: "#e6e6e6"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 487.60717,
    cy: 103.74958,
    r: 5.88339,
    fill: "#b3b3b3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M705.70159,282.88315a6.88355,6.88355,0,1,1,6.88355-6.88379A6.89127,6.89127,0,0,1,705.70159,282.88315Zm0-11.76709a4.88355,4.88355,0,1,0,4.88355,4.8833A4.88872,4.88872,0,0,0,705.70159,271.11606Z",
    transform: "translate(-218.0945 -172.25)",
    fill: "#e6e6e6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M530.5643,353.31017,458.212,465.93357a3.369,3.369,0,0,1-4.65516,1.01509l-.00188-.00121L262.36966,344.12483a2.842,2.842,0,0,1-.38606-.29266,3.367,3.367,0,0,1-.62782-4.36438l72.35234-112.6234a3.369,3.369,0,0,1,4.6551-1.01509l.00192.00123L529.5504,348.65315a3.369,3.369,0,0,1,1.01511,4.65515Z",
    transform: "translate(-218.0945 -172.25)",
    fill: "#e6e6e6"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 138.58941,
    cy: 124.80725,
    r: 29.56668,
    fill: "#00b0ff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M385.44431,423.82919,263.4115,345.432a2.95738,2.95738,0,0,1-.43282-.3291l121.94078-62.894a4.80316,4.80316,0,0,1,7.03446,4.51913l-4.36527,91.97329-.20663,4.40238Z",
    transform: "translate(-218.0945 -172.25)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "167.35 251.579 125.685 224.812 165.224 208.243 168.071 207.049 169.494 206.451 169.288 210.854 167.35 251.579",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M453.39128,467.48017,347.84293,399.673,387.382,383.1037l2.84678-1.19457,51.52493-21.59436c3.37744-1.41493,7.68248,1.12751,8.31264,4.66416a5.72642,5.72642,0,0,1,.07635.72515Z",
    transform: "translate(-218.0945 -172.25)",
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M555.78844,348.37529a12.13173,12.13173,0,0,0-5.25524-12.89675l-210.18-135.02535a12.09951,12.09951,0,0,0-16.7261,3.64144L220.01039,365.384a12.12136,12.12136,0,0,0,3.64144,16.7261l210.18,135.02535a12.12135,12.12135,0,0,0,16.7261-3.64144L554.17464,352.20464A12.01219,12.01219,0,0,0,555.78844,348.37529ZM449.35984,512.72437a10.69318,10.69318,0,0,1-14.75832,3.213l-210.18-135.02535a10.69318,10.69318,0,0,1-3.213-14.75833L324.82519,204.86431a10.69318,10.69318,0,0,1,14.75833-3.213l210.18,135.02535a10.69319,10.69319,0,0,1,3.213,14.75833Z",
    transform: "translate(-218.0945 -172.25)",
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M548.87141,399.53783a12.13174,12.13174,0,0,0-11.39218-8.01012H287.66435a12.0995,12.0995,0,0,0-12.10419,12.10418V595.3366a12.12136,12.12136,0,0,0,12.10419,12.10419H537.47923a12.12136,12.12136,0,0,0,12.10419-12.10419V403.63189A12.01214,12.01214,0,0,0,548.87141,399.53783Z",
    transform: "translate(-218.0945 -172.25)",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M548.87141,399.53783a12.13174,12.13174,0,0,0-11.39218-8.01012H287.66435a12.0995,12.0995,0,0,0-12.10419,12.10418V595.3366a12.12136,12.12136,0,0,0,12.10419,12.10419H537.47923a12.12136,12.12136,0,0,0,12.10419-12.10419V403.63189A12.01214,12.01214,0,0,0,548.87141,399.53783Zm-.712,195.79877a10.69318,10.69318,0,0,1-10.68017,10.68016H287.66435a10.69318,10.69318,0,0,1-10.68016-10.68016V403.63189a10.69318,10.69318,0,0,1,10.68016-10.68016H537.47923a10.69318,10.69318,0,0,1,10.68017,10.68016Z",
    transform: "translate(-218.0945 -172.25)",
    fill: "#3f3d56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M530.31657,417.32344V551.1849a3.369,3.369,0,0,1-3.36792,3.37016H299.7082a2.84014,2.84014,0,0,1-.483-.03756,3.367,3.367,0,0,1-2.88717-3.3326V417.32344a3.369,3.369,0,0,1,3.36788-3.37013H526.94641a3.369,3.369,0,0,1,3.37016,3.36791Z",
    transform: "translate(-218.0945 -172.25)",
    fill: "#e6e6e6"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 135.52423,
    cy: 291.72808,
    r: 29.56668,
    fill: "#00b0ff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M446.33653,555.09171H301.29127a2.957,2.957,0,0,1-.542-.04294L369.349,436.22418a4.80317,4.80317,0,0,1,8.361,0l46.039,79.74052,2.20564,3.81559Z",
    transform: "translate(-218.0945 -172.25)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "228.242 382.842 178.72 382.842 203.03 347.53 204.78 344.987 205.655 343.715 207.86 347.53 228.242 382.842",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M527.09666,555.09171H401.64443l24.31019-35.31143,1.74945-2.54374L459.38242,471.219c2.07682-3.016,7.073-3.20378,9.51476-.56884a5.724,5.724,0,0,1,.45619.56884Z",
    transform: "translate(-218.0945 -172.25)",
    fill: "#3f3d56"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M548.87141,399.53783a12.13174,12.13174,0,0,0-11.39218-8.01012H287.66435a12.0995,12.0995,0,0,0-12.10419,12.10418V595.3366a12.12136,12.12136,0,0,0,12.10419,12.10419H537.47923a12.12136,12.12136,0,0,0,12.10419-12.10419V403.63189A12.01214,12.01214,0,0,0,548.87141,399.53783Zm-.712,195.79877a10.69318,10.69318,0,0,1-10.68017,10.68016H287.66435a10.69318,10.69318,0,0,1-10.68016-10.68016V403.63189a10.69318,10.69318,0,0,1,10.68016-10.68016H537.47923a10.69318,10.69318,0,0,1,10.68017,10.68016Z",
    transform: "translate(-218.0945 -172.25)",
    fill: "#3f3d56"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.72d50d40b06b69f040eda198cc897401.svg";
export { ForwardRef as ReactComponent };